import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { IFilterProperty } from '../../../../../shared/interfaces/filters/filter-property.interface';
import { FilterRule } from '../../../../../shared/interfaces/filters/filter-rule.type';
import { FilterOptionComponent } from '../filter-option/filter-option.component';

@Component({
  standalone: false,
  selector: 'suvo-bi-checkbox-filter-option',
  templateUrl: './checkbox-filter-option.component.html',
  styleUrls: ['./checkbox-filter-option.component.scss'],
})
export class CheckboxFilterOptionComponent extends FilterOptionComponent implements OnInit {
  checked;

  constructor() {
    super();

    this.formGroup = new FormGroup({
      checkbox: new FormControl(),
    });
    this.hookForm(this.formGroup);
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.formGroup.controls.checkbox.value) {
      this.formGroup.controls.checkbox.setValue(this.option.filterMethodConfig.defaultValue, {
        emitEvent: false,
      });
    }
  }

  getFilterRules(values: any): FilterRule[] {
    const hasTrueValue = Object.prototype.hasOwnProperty.call(
      this.option.filterMethodConfig,
      'trueValue',
    );
    const hasFalseValue = Object.prototype.hasOwnProperty.call(
      this.option.filterMethodConfig,
      'falseValue',
    );

    const eqValue = values.checkbox
      ? hasTrueValue
        ? this.option.filterMethodConfig.trueValue
        : true
      : hasFalseValue
        ? this.option.filterMethodConfig.falseValue
        : false;

    return [
      {
        key: this.option.filterPropertyKeys[0],
        eq: eqValue,
      },
    ];
  }

  patchRules(rules: FilterRule[]) {
    const property = rules[0] as IFilterProperty;
    const patchValue = property?.eq;

    const hasTrueValue = Object.prototype.hasOwnProperty.call(
      this.option.filterMethodConfig,
      'trueValue',
    );
    const checked = hasTrueValue
      ? this.areEqual(patchValue, this.option.filterMethodConfig.trueValue)
      : !!patchValue;

    this.formGroup.controls.checkbox.patchValue(checked, {
      emitEvent: false,
    });
  }

  private areEqual(left: unknown, right: unknown): boolean {
    if (left === right) {
      return true;
    }

    return JSON.stringify(left) === JSON.stringify(right);
  }

  onToggle(ev) {
    this.checked = ev.checked;
  }
}
